/*
 *   File : manage-banner.js
 *   Author : https://evoqins.com
 *   Description : Manage service and promotion banner component
 *   Integrations : NA
 *   Version : 1.0.0
*/
import { useEffect, useState } from 'react';

//Custom components
import { CustomSelectBox, CustomTextInput, FileSelector } from '../FormElements';
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton, TextButton } from '../Buttons';
import { FileUploader } from 'react-drag-drop-files';
import { toast } from 'react-toastify';
import { APIService, AWSService } from '../../Service';
import { Loader } from '../Others';

const ManageBannerModal = (props) => {

    const [title, setTitle] = useState("");
    const [titleError, setTitleError] = useState("");

    const [subTitle, setSubTitle] = useState("");
    const [subTitleError, setSubTitleError] = useState("");

    const [message, setMessage] = useState("");
    const [messageError, setMessageError] = useState("");
    const [isShowImage, setIsShowImage] = useState(false);


    const [serviceTitle, setServiceTitle] = useState("");
    const [serviceTitleError, setServiceTitleError] = useState("");
    const [serviceDescription, setServiceDescription] = useState("");
    const [serviceDescriptionError, setServiceDescriptionError] = useState("");
    const [isAttachBannerImage, setIsAttachBannerImage] = useState(false);
    const [selectedRedirectionLink, setSelectedRedirectionLink] = useState(null);
    const [selectedRedirectionLinkError, setSelectedRedirectionLinkError] = useState("");
    const [days, setDays] = useState(null);
    const [daysError, setDaysError] = useState("");

    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState("");
    const [fileLoader, setFileLoader] = useState(false);

    const [linkOptions, setLinkOptions] = useState([]);
    const [linkOptionLoader, setLinkOptionLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);

    const [buttonName, setButtonName] = useState("");
    const [buttonNameError, setButtonNameError] = useState("");


    const [promotionRedirectionLink, setPromotionRedirectionLink] = useState(null);
    const [promotionButtonName, setPromotionButtonName] = useState("");

    const [promotionFile, setPromotionFile] = useState(null);
    const [promotionFileError, setPromotionFileError] = useState("");

    useEffect(() => {
        // console.log("props.data", props.data);

        if (Object.keys(props.data).length !== 0) {
            if (props.type === 1) {
                setTitle(props.data.title ?? "");
                setMessage(props.data.description ?? "");
                setIsShowImage(props.data.show_icon ?? false);
                setSubTitle(props.data.sub_title ?? "")

                if (props.data.image_url !== null) {
                    setPromotionFile({ name: props.data.image_url, url: props.data.image_url });
                }
                if (props.data.redirection_url !== null) {
                    setPromotionRedirectionLink({ value: props.data.redirection_url, label: props.data.redirection_url });
                }

                setPromotionButtonName(props.data.button_name ?? "")
            } else {
                setServiceTitle(props.data.title ?? "");
                setServiceDescription(props.data.description ?? "");
                setIsAttachBannerImage(props.data.show_icon ?? false);

                if (props.data.image_url !== null) {
                    setFile({ name: props.data.image_url, url: props.data.image_url });
                }
                if (props.data.redirection_url !== null) {
                    setSelectedRedirectionLink({ value: props.data.redirection_url, label: props.data.redirection_url });
                }
                setDays(props.data.days ?? null);

                // setButtonName(props.data.button_name ?? "")
            }
        }
    }, [props.data, props.type]);

    useEffect(() => {
        _getFilterData();
        setLinkOptionLoader(true);
    }, []);

    useEffect(() => {
        setTitleError("");
    }, [title]);

    useEffect(() => {
        setSubTitleError("");
    }, [subTitle]);

    useEffect(() => {
        setMessageError("");
    }, [message]);

    useEffect(() => {
        setServiceTitleError("");
    }, [serviceTitle]);

    useEffect(() => {
        setServiceDescriptionError("");
    }, [serviceDescription]);


    useEffect(() => {
        setSelectedRedirectionLinkError("");
    }, [selectedRedirectionLink]);

    useEffect(() => {
        setDaysError("");
    }, [days]);

    useEffect(() => {
        setFileError("");
    }, [file]);


    useEffect(() => {
        setPromotionFileError("");
    }, [promotionFile]);

    useEffect(() => {
        setButtonNameError("");
    }, [buttonName]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("manage-banner-modal-close");
        button.click();
        props.handleClose();
    };

    // handle success modal
    const _handleSuccess = () => {
        _handleCloseModal();
        props.handleSuccess();
    };

    // handle change
    const _handleChange = (file) => {



        if (file.size > 1024 * 1024 * 10) {
            if (isShowImage === true) {
                setPromotionFileError("File size exceeds the maximum limit of 10 MB");
            } else {
                setFileError("File size exceeds the maximum limit of 10 MB");
            }
            return;
        }

        _getPresignedUrl(file);
    };

    // handle submit
    const _handleSubmit = () => {
        let is_valid = true;

        if (title.trim().length === 0) {
            setTitleError("Please provide banner title");
            is_valid = false;
        }

        if (subTitle.trim().length === 0) {
            setSubTitleError("Please provide sub title");
            is_valid = false;
        }

        if (message.trim().length === 0) {
            setMessageError("Please provide banner message");
            is_valid = false;
        }

        if (isShowImage === true && promotionFile === null) {
            setPromotionFileError("Please upload banner image");
            is_valid = false;
        }

        if (is_valid === true) {
            _upsertBanner();
        }

    };

    // handle submit promotion  banner
    const _handleSubmitService = () => {
        let is_valid = true;

        if (serviceTitle.trim().length === 0) {
            setServiceTitleError("Please provide banner title");
            is_valid = false;
        }

        if (serviceDescription.trim().length === 0) {
            setServiceDescriptionError("Please provide banner description");
            is_valid = false;
        }


        if (isAttachBannerImage === true && file === null) {
            setFileError("Please upload banner image");
            is_valid = false;
        }

        if (is_valid === true) {
            _upsertBanner();
        }

    };


    // Get - presigned url
    async function _getPresignedUrl(file) {
        setFileLoader(true);

        let is_post = true;
        let url = 'file/upload';
        let data = {
            "type": "ADMIN",
            "file": file.name,
            "is_public": true
        };

        try {
            let response = await APIService(is_post, url, data);
            if (response.status_code == 200) {
                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {

                        if (isShowImage === true) {
                            setPromotionFile({ name: file.name, url: response.data.view_info });
                        } else {
                            setFile({ name: file.name, url: response.data.view_info });
                        }

                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) { }
        setFileLoader(false);
    };

    // API - Get filter data
    const _getFilterData = () => {
        let is_post = false;
        let url = 'banner/filter-data';
        let request = {}

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setLinkOptions(response.data.redirect);
            } else {
                setLinkOptions([]);
            }
            setLinkOptionLoader(false);
        })
    };

    // API - Create banner
    const _upsertBanner = () => {
        setButtonLoader(true);

        let promotion_request = {
            "type": 1,
            "banner_id": props.bannerId,
            "title": title,
            "sub_title": subTitle,
            "description": message,
            "show_icon": isShowImage,

            "image_url": isShowImage === true ? promotionFile?.url : null,
            "redirection_url": promotionRedirectionLink?.value || null,
            "button_name": promotionButtonName,
        }

        let service_request = {
            "type": 2,
            "banner_id": props.bannerId,
            "title": serviceTitle,
            "description": serviceDescription,
            "show_icon": isAttachBannerImage,
            "image_url": isAttachBannerImage === true ? file?.url : null,
            "redirection_url": selectedRedirectionLink?.value || null,
            // "button_name": buttonName,
            "days": days,
        }

        let is_post = true;
        let url = 'banner/upsert';
        let request = props.type === 1 ? promotion_request : service_request

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                _handleSuccess();

                toast.dismiss();
                toast.success(props.bannerId !== null ? "Successfully created banner" : "Successfully updated banner", {
                    type: "success",
                    className: "e-toast",
                });
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setButtonLoader(false);
        })
    };


    return (
        <div className="modal fade"
            id="manage-banner-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="manageModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28`}>
                <span id='manage-banner-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                {props.type === 1 ?
                    <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                        {/* modal header */}
                        <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                            <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                {props.title}
                            </h6>
                            <Icon icon='close'
                                size="1.125rem"
                                className="d-flex cursor-pointer"
                                onClick={_handleCloseModal} />
                        </div>


                        <div className='modal-body pt-0 padding-32px-lr padding-32px-bottom'>
                            <div className='d-flex flex-column gap-3'>
                                <CustomTextInput label="Add title"
                                    placeholder="Enter banner title"
                                    type="text"
                                    autoFocus={true}
                                    required={true}
                                    value={title}
                                    maxLength={100}
                                    error={titleError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSubmit}
                                    handleChange={(e) => setTitle(e)} />

                                <CustomTextInput label="Add sub title"
                                    placeholder="Enter banner sub title"
                                    type="text"
                                    required={true}
                                    value={subTitle}
                                    error={subTitleError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSubmit}
                                    handleChange={(e) => setSubTitle(e)} />

                                <CustomTextInput label="Add message"
                                    placeholder="Enter banner message"
                                    type="text"
                                    required={true}
                                    value={message}
                                    maxLength={100}
                                    error={messageError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSubmit}
                                    handleChange={(e) => setMessage(e)} />

                                <div className='d-flex align-items-center gap-12px'>
                                    <label className={`d-flex e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px `}>
                                        Show image in banner
                                    </label>
                                    <label class="switch d-flex">
                                        <input type="checkbox"
                                            checked={isShowImage}
                                            onChange={(e) => setIsShowImage(e.target.checked)} />
                                        <span class="slider"></span>
                                    </label>
                                </div>

                                {isShowImage === true &&
                                    <div className='position-relative e-modal-file-upload'>
                                        <FileUploader
                                            name="file"
                                            multiple={false}
                                            types={["JPEG", "PNG"]}
                                            handleChange={(file) => { _handleChange(file) }}
                                            children={
                                                <div className="d-flex align-items-start gap-3 w-">
                                                    <div>
                                                        <img src={file !== null ? require("../../Assets/Image/Modal/file-active.svg").default : require("../../Assets/Image/Modal/file-inactive.svg").default}
                                                            draggable={false}
                                                            alt='file' />
                                                    </div>

                                                    <div className='w-100'>
                                                        <p className='mb-1 e-text-dark-gray e-font-14 e-primary-font e-font-weight-400 line-height-20px'>
                                                            Attach banner image
                                                        </p>

                                                        <p className='mb-2 pb-1 e-text-dark-silver e-font-10 e-primary-font e-font-weight-400 line-height-12px'>
                                                            Select and upload the file. JPEG, PNG formats up to 10MB
                                                        </p>

                                                        {fileLoader ?
                                                            <div className="loader justify-content-start pt-2 mt-1">
                                                                <div className="ball"></div>
                                                                <div className="ball"></div>
                                                                <div className="ball"></div>
                                                                <div className="ball"></div>
                                                            </div>
                                                            :
                                                            <>
                                                                {file === null &&
                                                                    <p className='mb-0 e-font-weight-600 e-text-blue-violet e-primary-font e-font-12 line-height-14px'>
                                                                        Upload
                                                                    </p>
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        />

                                        {promotionFile && (
                                            <div className='ps-4 ms-4 d-flex flex-column '>

                                                <div className='d-flex align-items-center justify-content-between w-100'>
                                                    <div className='d-flex align-items-center gap-1'>
                                                        <img
                                                            src={require("../../Assets/Image/Modal/tick-icon.svg").default}
                                                            draggable={false}
                                                            alt='file'
                                                        />

                                                        <div className='e-bg-green-crayola border-radius-8'
                                                            style={{ height: "4px", width: "230px" }}>
                                                        </div>
                                                    </div>

                                                    <p className='mb-0 e-font-weight-600 e-text-carmine-pink e-primary-font e-font-12 line-height-14px cursor-pointer'
                                                        onClick={() => setPromotionFile(null)}>
                                                        Remove
                                                    </p>
                                                </div>

                                                <p className='mb-0 ps-4 ms-1 margin--8px-top e-text-dark-silver e-font-10 e-primary-font e-font-weight-400 line-height-12px'>
                                                    {promotionFile?.name || "-"}
                                                </p>
                                            </div>
                                        )}

                                        {promotionFileError && (
                                            <p className="position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px e-font-weight-500">
                                                {promotionFileError}
                                            </p>
                                        )}
                                    </div>
                                }

                                <CustomSelectBox title='Add redirection link'
                                    placeholder='Add redirection page'
                                    controlWidth='w-100'
                                    options={linkOptions}
                                    loader={linkOptionLoader}
                                    isSearchable={false}
                                    borderColor={`0.031rem solid #414141`}
                                    padding="0.75rem 1rem"
                                    value={promotionRedirectionLink}
                                    onChange={(data) => setPromotionRedirectionLink(data)} />

                                <CustomTextInput label="Button name"
                                    placeholder="Enter button name"
                                    type="text"
                                    // required={true}
                                    value={promotionButtonName}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSubmit}
                                    handleChange={(e) => setPromotionButtonName(e)} />
                            </div>
                        </div>

                        {/* Modal footer */}
                        <div className='modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-3'>
                            <SecondaryButton name="Cancel"
                                paddingBlock="padding-14px-tb padding-54px-lr"
                                onClick={_handleCloseModal} />

                            <PrimaryButton name={props.bannerId !== null ? "Update" : "Publish"}
                                paddingBlock="padding-14px-tb px-3"
                                className='w-186px'
                                loader={buttonLoader}
                                onClick={_handleSubmit} />
                        </div>
                    </div>
                    :
                    <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">
                        {/* modal header */}
                        <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                            <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                {props.title}
                            </h6>
                            <Icon icon='close'
                                size="1.125rem"
                                className="d-flex cursor-pointer"
                                onClick={_handleCloseModal} />
                        </div>


                        <div className='modal-body pt-0 padding-32px-lr padding-32px-bottom'>
                            <div className='d-flex flex-column gap-3'>
                                <CustomTextInput label="Add title"
                                    placeholder="Enter banner title"
                                    type="text"
                                    autoFocus={true}
                                    required={true}
                                    value={serviceTitle}
                                    error={serviceTitleError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSubmitService}
                                    handleChange={(e) => setServiceTitle(e)} />

                                <CustomTextInput label="Add description"
                                    placeholder="Enter banner description"
                                    type="text"
                                    required={true}
                                    maxLength={100}
                                    value={serviceDescription}
                                    error={serviceDescriptionError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSubmitService}
                                    handleChange={(e) => setServiceDescription(e)} />

                                <div className='d-flex align-items-center gap-12px'>
                                    <label className={`d-flex e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px `}>
                                        Attach banner image
                                    </label>
                                    <label class="switch d-flex">
                                        <input type="checkbox"
                                            checked={isAttachBannerImage}
                                            onChange={(e) => setIsAttachBannerImage(e.target.checked)} />
                                        <span class="slider"></span>
                                    </label>
                                </div>


                                {isAttachBannerImage === true &&
                                    <div className='position-relative e-modal-file-upload'>
                                        <FileUploader
                                            name="file"
                                            multiple={false}
                                            types={["JPEG", "PNG"]}
                                            handleChange={(file) => { _handleChange(file) }}
                                            children={
                                                <div className="d-flex align-items-start gap-3 w-">
                                                    <div>
                                                        <img src={file !== null ? require("../../Assets/Image/Modal/file-active.svg").default : require("../../Assets/Image/Modal/file-inactive.svg").default}
                                                            draggable={false}
                                                            alt='file' />
                                                    </div>

                                                    <div className='w-100'>
                                                        <p className='mb-1 e-text-dark-gray e-font-14 e-primary-font e-font-weight-400 line-height-20px'>
                                                            Attach banner image
                                                        </p>

                                                        <p className='mb-2 pb-1 e-text-dark-silver e-font-10 e-primary-font e-font-weight-400 line-height-12px'>
                                                            Select and upload the file. JPEG, PNG formats up to 10MB
                                                        </p>

                                                        {fileLoader ?
                                                            <div className="loader justify-content-start pt-2 mt-1">
                                                                <div className="ball"></div>
                                                                <div className="ball"></div>
                                                                <div className="ball"></div>
                                                                <div className="ball"></div>
                                                            </div>
                                                            :
                                                            <>
                                                                {file === null &&
                                                                    <p className='mb-0 e-font-weight-600 e-text-blue-violet e-primary-font e-font-12 line-height-14px'>
                                                                        Upload
                                                                    </p>
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        />

                                        {file && (
                                            <div className='ps-4 ms-4 d-flex flex-column '>

                                                <div className='d-flex align-items-center justify-content-between w-100'>
                                                    <div className='d-flex align-items-center gap-1'>
                                                        <img
                                                            src={require("../../Assets/Image/Modal/tick-icon.svg").default}
                                                            draggable={false}
                                                            alt='file'
                                                        />

                                                        <div className='e-bg-green-crayola border-radius-8'
                                                            style={{ height: "4px", width: "230px" }}>
                                                        </div>
                                                    </div>

                                                    <p className='mb-0 e-font-weight-600 e-text-carmine-pink e-primary-font e-font-12 line-height-14px cursor-pointer'
                                                        onClick={() => setFile(null)}>
                                                        Remove
                                                    </p>
                                                </div>

                                                <p className='mb-0 ps-4 ms-1 margin--8px-top e-text-dark-silver e-font-10 e-primary-font e-font-weight-400 line-height-12px'>
                                                    {file?.name || "-"}
                                                </p>
                                            </div>
                                        )}

                                        {fileError && (
                                            <p className="position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px e-font-weight-500">
                                                {fileError}
                                            </p>
                                        )}
                                    </div>
                                }

                                <CustomSelectBox title='Add redirection link'
                                    placeholder='Add redirection page'
                                    controlWidth='w-100'
                                    // required={true}
                                    options={linkOptions}
                                    loader={linkOptionLoader}
                                    isSearchable={false}
                                    borderColor={`0.031rem solid #414141`}
                                    padding="0.75rem 1rem"
                                    value={selectedRedirectionLink}
                                    error={selectedRedirectionLinkError}
                                    onChange={(data) => setSelectedRedirectionLink(data)} />

                                {/* <CustomTextInput label="Button name"
                                    placeholder="Enter button name"
                                    type="text"
                                    // required={true}
                                    value={buttonName}
                                    error={buttonNameError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSubmitService}
                                    handleChange={(e) => setButtonName(e)} /> */}

                                <CustomTextInput label="Set number of days to display banner"
                                    placeholder="Add days"
                                    type="number"
                                    // required={true}
                                    value={days}
                                    error={daysError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSubmitService}
                                    handleChange={(e) => setDays(e)} />
                            </div>
                        </div>

                        {/* Modal footer */}
                        <div className='modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-3'>
                            <SecondaryButton name="Cancel"
                                paddingBlock="padding-14px-tb padding-54px-lr"
                                onClick={_handleCloseModal} />

                            <PrimaryButton name={props.bannerId !== null ? "Update" : "Publish"}
                                paddingBlock="padding-14px-tb px-3"
                                className='w-186px'
                                loader={buttonLoader}
                                onClick={_handleSubmitService} />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default ManageBannerModal;